import * as t from "io-ts";
import { SearchCriteria } from "./report";

export const CompanyDisposalReportValidator = t.intersection([
  t.type({
    fileName: t.string,
    fileDisplayName: t.string,
    fileUrl: t.string,
    fromDttm: t.number,
    toDttm: t.number,
    reportTime: t.string,
    vendorName: t.string,
    operatorName: t.string,
    regionName: t.string,
    timeZone: t.string,
    totalCost: t.number,
  }),
  t.partial({
    siteName: t.string,
    category: t.string,
  }),
]);

export type CompanyDisposalReport = t.TypeOf<typeof CompanyDisposalReportValidator>;

export interface CompanyDisposalReportCriteria {
  criteriaList: SearchCriteria[];
  sortByPickup: boolean;
}
